import { useCallback, useEffect, useState } from 'react';
import { api, useAuth } from '../services/AuthService';
import { useAutoPrint } from '../hooks/useAutoPrint';

// Mantem a impressao automatica ativa em qualquer tela do painel, inclusive
// no fechamento de caixa. A estacao de impressao continua usando seu proprio
// listener por estar fora do Layout administrativo.
function AutoPrintListener() {
  const { user, isAdminLanchonete } = useAuth();
  const [lanchonete, setLanchonete] = useState(null);

  const loadLanchonete = useCallback(async () => {
    if (!isAdminLanchonete() || !user?.lanchonete_id) {
      setLanchonete(null);
      return;
    }

    try {
      const response = await api.get(`/lanchonetes/${user.lanchonete_id}`);
      setLanchonete(response.data);
    } catch (error) {
      console.error('Erro ao carregar configuracao de impressao:', error);
      setLanchonete(null);
    }
  }, [isAdminLanchonete, user?.lanchonete_id]);

  useEffect(() => {
    loadLanchonete();
  }, [loadLanchonete]);

  useAutoPrint({
    lanchonete,
    // Mantem um unico listener confiavel do layout ativo inclusive na tela
    // Minha Lanchonete. O controle persistido impede uma segunda via caso o
    // listener legado dessa tela receba o mesmo evento.
    enabled: Boolean(lanchonete?.auto_print),
    showToasts: true
  });

  return null;
}

export default AutoPrintListener;
